import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { useParams } from 'react-router-dom'

import { Button, BUTTON_VARIANT_PRIMARY, Flex } from 'mailup-web-components'

import BoxInfo from 'Pages/EmailSendingWizard/components/BoxInfo'
import BoxSenderConfig from 'Pages/EmailSendingWizard/components/BoxSenderConfig'
import BoxRecipients from 'Pages/EmailSendingWizard/components/BoxRecipients'
import { RECIPIENTS_NONE } from 'Pages/EmailSendingWizard/const'
import { pageState } from 'Pages/EmailSendingWizard/recoil/state/page'
import { isValidFormState } from 'Pages/EmailSendingWizard/recoil/state/senderInfo'
import { goToStep2Callback } from '../recoil/callbacks/callback'

const SendingWizardFisrtStep = () => {
  const intl = useIntl()
  const { id } = useParams()
  const [{ recipients }, setPageState] = useRecoilState(pageState)
  const isValidForm = useRecoilValue(isValidFormState)
  const goToStep2 = useRecoilCallback(goToStep2Callback, [])

  const handleContinue = () => {
    goToStep2()
  }

  return (
    <>
      <BoxInfo idMessage={parseInt(id, 0)} />
      <BoxSenderConfig />
      <BoxRecipients />
      <Flex justifyContent='flex-end'>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleContinue}
          disabled={recipients === RECIPIENTS_NONE || !isValidForm}
        >
          {intl.formatMessage({
            id: 'Load.EmailSendingWizard.BtnContinue'
          })}
        </Button>
      </Flex>
    </>
  )
}

export default SendingWizardFisrtStep
